module.exports = __webpack_public_path__ + "TRUONGabout-3.d1588db4.png";